<template>
    <el-dialog
        title="添加团队成员"
        :visible.sync="teamMembersAddVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        custom-class="custom-form-dialog team-members-dialog"
    >
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
            <el-form-item label="选择成员" prop="member_uid">
                <el-select
                    placeholder="请选择或搜索人员"
                    v-model="formData.member_uid"
                    :remote-method="getUserList"
                    filterable
                    remote
                    reserve-keyword
                >
                    <el-option
                        v-for="userItem in userList"
                        :key="userItem.uid"
                        :value="userItem.uid"
                        :label="userItem.name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="auth">
                <template #label>
                    <span class="bold-text">权限类型</span>
                </template>
                <el-radio-group v-model="formData.auth">
                    <el-radio label="1">只读</el-radio>
                    <el-radio label="2">读写</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
        <DirectorChangeSync
            :syncChangeTitle="syncChangeTitle"
            :syncChangeType="2"
            :directorChangeSyncVisible.sync="directorChangeSyncVisible"
            v-if="directorChangeSyncVisible"
        />
    </el-dialog>
</template>
<script>
import { GetUserList, HandleCustomerMember } from "@/api";
import DirectorChangeSync from "./director_change_sync.vue";
export default {
    name: "TeamMembersAdd",
    components: { DirectorChangeSync },
    props: {
        customer_id: "",
        teamMembersAddVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            formLoading: true,
            formData: {
                member_uid: "",
                auth: "1",
            },
            formRules: {
                member_uid: [{ required: true, message: "请选择成员", trigger: "change" }],
            },
            userList: [],
            btnDisabled: false,
            syncChangeTitle: "同步增加团队成员",
            directorChangeSyncVisible: false,
        };
    },
    mounted() {
        this.getUserList();
    },
    methods: {
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.userList = res.data || [];
                }
            });
            this.formLoading = false;
        },
        handleDialogClose() {
            this.$emit("update:teamMembersAddVisible", false);
        },
        handleDialogConfirm() {
            // this.directorChangeSyncVisible = true
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    this.btnDisabled = true;
                    this.formLoading = true;
                    const params = {
                        customer_id: this.customer_id,
                        create: [
                            {
                                member_uid: this.formData.member_uid,
                                auth: this.formData.auth,
                            },
                        ],
                    };
                    HandleCustomerMember(params).then((res) => {
                        this.btnDisabled = true;
                        this.formLoading = true;
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.$emit("update:teamMembersAddVisible", false);
                            this.$emit("createCallback");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.team-members-dialog {
    .bold-text {
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
    }
}
</style>
